import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, inject, PLATFORM_ID } from '@angular/core';
import { PresaleDataService } from '../../services/connection-services/data.service';

interface InfraFeature {
    titleKey: string;
    subKey: string;
    glowColor: string;
    icon: string;
}

@Component({
    selector: 'app-infra',
    templateUrl: './infra.component.html',
    styleUrls: ['./infra.component.scss'],
    standalone: false,
})
export class InfraComponent implements AfterViewInit {
    readonly infraFeatures: InfraFeature[] = [
        { titleKey: 'infra.feat1_title', subKey: 'infra.feat1_sub', glowColor: 'rgba(105,218,255,0.2)',icon: '/assets/images/png/network-icon.jpg' },
        { titleKey: 'infra.feat2_title', subKey: 'infra.feat2_sub', glowColor: 'rgba(195,244,0,0.2)', icon: '/assets/images/png/phone-icon.jpg' },
    ];

    private readonly _platformId = inject(PLATFORM_ID);
    private readonly cdRef = inject(ChangeDetectorRef);
    private readonly dataService = inject(PresaleDataService);

    ngAfterViewInit(): void {
        // Force change detection after view init — needed for SSR hydration
        if (isPlatformBrowser(this._platformId)) {
            this.cdRef.detectChanges();
        }
    }

    buyNow() {
        this.dataService.connectWallet()
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
}
